var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1034_82447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 183H19.5M400 183H144M144 183L162.27 203M144 183H124M313 368L273.719 325M162.27 203H400M162.27 203L179.627 222M179.627 222H397.5M179.627 222L198.811 243M198.811 243H395M198.811 243L217.081 263M217.081 263H387M217.081 263L235.351 283M235.351 283H379M235.351 283L255.449 305M255.449 305H369M255.449 305L273.719 325M273.719 325H355M124 183L280 386M124 183H102M102 183L235.351 401M102 183H81M81 183L179.627 401M81 183H60M60 183L124 386M60 183H39M39 183L65 351M39 183H19.5M19.5 183V283",
    stroke: "#8896AB",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0001 82.9999C34.6001 68.5999 45.6668 66.3332 51.0001 66.9999C56.3334 59.3332 74 44.3998 102 45.9998C113.667 46.3332 138 54.1999 142 82.9999C155.333 81.9999 182.6 83.5998 185 97.9998C188 116 133 111 115 108C104.333 113.333 83.6 119.2 58 116C47.3333 113.667 19.0001 110 19.0001 97.9998C17.4001 86.7998 27.6668 83.3332 33.0001 82.9999Z",
    stroke: "#8896AB",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 83C190 57.4 219 57.6666 231 61C233.4 44.2 246 48.6666 252 53C268 38.6666 306 21.8 330 69C339 67.6666 356.4 70.1999 354 90.9999C367.333 102.333 364 122 343 122C334.667 128.333 314.6 137.2 293 122C269.667 127.667 214.2 132.8 179 108",
    stroke: "#8896AB",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.287 82.5C150.097 81.0267 150 79.5247 150 78C150 58.67 165.67 43 185 43C197.326 43 208.163 49.3712 214.399 59",
    stroke: "#8896AB",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1034_82447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorState);
export default __webpack_public_path__ + "static/media/errorState.5adc0b0c4c478b137814cb7d3eecf00c.svg";
export { ForwardRef as ReactComponent };